import type { Components, Theme } from '@mui/material/styles';
import { soft } from './soft';

export const inputs: Components<Theme> = {
  MuiButtonBase: {
    defaultProps: { disableRipple: true },
  },
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        minHeight: 36,
        paddingInline: theme.spacing(1.75),
        transition: theme.transitions.create(['background-color', 'border-color', 'box-shadow', 'color'], {
          duration: theme.transitions.duration.shortest,
        }),
        [theme.breakpoints.down('md')]: { minHeight: 44 },
        '&:active': { transform: 'translateY(0.5px)' },
        variants: [
          {
            props: { variant: 'outlined', color: 'primary' },
            style: {
              color: theme.palette.text.primary,
              borderColor: theme.palette.surface.border,
              backgroundColor: theme.palette.background.paper,
              '&:hover': { backgroundColor: theme.palette.surface.subtle, borderColor: theme.palette.surface.borderStrong },
            },
          },
          { props: { variant: 'contained', color: 'primary' }, style: { '&:hover': { backgroundColor: theme.palette.primary.light } } },
        ],
      }),
      sizeSmall: ({ theme }) => ({
        minHeight: 32,
        paddingInline: theme.spacing(1.25),
        fontSize: '0.8125rem',
        [theme.breakpoints.down('md')]: { minHeight: 40 },
      }),
      startIcon: { marginRight: 6 },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        '&:hover': { backgroundColor: theme.palette.surface.subtle },
      }),
    },
  },
  MuiTextField: {
    defaultProps: { size: 'small' },
  },
  MuiSelect: {
    defaultProps: { size: 'small' },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        transition: theme.transitions.create(['box-shadow', 'border-color'], { duration: theme.transitions.duration.shortest }),
        '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.surface.border },
        '&:hover:not(.Mui-disabled, .Mui-error) .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.surface.borderStrong },
        '&.Mui-focused:not(.Mui-error)': { boxShadow: `0 0 0 3px ${soft(theme.palette.primary.main, 14)}` },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1 },
        '&.Mui-disabled': { backgroundColor: theme.palette.surface.subtle },
      }),
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }) => ({ color: theme.palette.text.secondary }),
    },
  },
  MuiFormHelperText: {
    styleOverrides: { root: { marginInline: 2 } },
  },
  MuiSwitch: {
    defaultProps: { disableRipple: true },
  },
  MuiLink: {
    defaultProps: { underline: 'hover' },
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.info.main,
        textDecorationColor: soft(theme.palette.info.main, 40),
        '&:hover': { color: theme.palette.info.dark },
      }),
    },
  },
};
